"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @index('./*.ts', pp => `import { ${pp.name} } from '${pp.path}';`)

var AllocationsQuery_1 = require("./AllocationsQuery");

exports.AllocationsQuery = AllocationsQuery_1.AllocationsQuery;

var BaseQuery_1 = require("./BaseQuery");

exports.BaseQuery = BaseQuery_1.BaseQuery;

var BreakdownAnalysisQuery_1 = require("./BreakdownAnalysisQuery");

exports.BreakdownAnalysisQuery = BreakdownAnalysisQuery_1.BreakdownAnalysisQuery;

var ClientConfigurationQuery_1 = require("./ClientConfigurationQuery");

exports.ClientConfigurationQuery = ClientConfigurationQuery_1.ClientConfigurationQuery;

var CommentaryQuery_1 = require("./CommentaryQuery");

exports.CommentaryQuery = CommentaryQuery_1.CommentaryQuery;

var DisclaimerQuery_1 = require("./DisclaimerQuery");

exports.DisclaimerQuery = DisclaimerQuery_1.DisclaimerQuery;

var DocumentQuery_1 = require("./DocumentQuery");

exports.DocumentQuery = DocumentQuery_1.DocumentQuery;

var SingleDocumentQuery_1 = require("./SingleDocumentQuery");

exports.SingleDocumentQuery = SingleDocumentQuery_1.SingleDocumentQuery;

var DynamicQuery_1 = require("./DynamicQuery");

exports.DynamicQuery = DynamicQuery_1.DynamicQuery;

var FundListsQuery_1 = require("./FundListsQuery");

exports.FundListsQuery = FundListsQuery_1.FundListsQuery;

var FundManagerQuery_1 = require("./FundManagerQuery");

exports.FundManagerQuery = FundManagerQuery_1.FundManagerQuery;

var FundManagersQuery_1 = require("./FundManagersQuery");

exports.FundManagersQuery = FundManagersQuery_1.FundManagersQuery;

var GlobalQuery_1 = require("./GlobalQuery");

exports.GlobalQuery = GlobalQuery_1.GlobalQuery;

var InputQuery_1 = require("./InputQuery");

exports.InputQuery = InputQuery_1.InputQuery;

var JoinQuery_1 = require("./JoinQuery");

exports.JoinQuery = JoinQuery_1.JoinQuery;

var ObjectQuery_1 = require("./ObjectQuery");

exports.ObjectQuery = ObjectQuery_1.ObjectQuery;

var PortfolioEntityQuery_1 = require("./PortfolioEntityQuery");

exports.PortfolioEntityQuery = PortfolioEntityQuery_1.PortfolioEntityQuery;

var PortfolioQuery_1 = require("./PortfolioQuery");

exports.PortfolioQuery = PortfolioQuery_1.PortfolioQuery;

var PropertyQuery_1 = require("./PropertyQuery");

exports.PropertyQuery = PropertyQuery_1.PropertyQuery;

var Query_1 = require("./Query");

exports.Query = Query_1.Query;

var ResponseQuery_1 = require("./ResponseQuery");

exports.ResponseQuery = ResponseQuery_1.ResponseQuery;

var ScenarioQuery_1 = require("./ScenarioQuery");

exports.ScenarioQuery = ScenarioQuery_1.ScenarioQuery;

var ScenarioReportQuery_1 = require("./ScenarioReportQuery");

exports.ScenarioReportQuery = ScenarioReportQuery_1.ScenarioReportQuery;

var StatisticQuery_1 = require("./StatisticQuery");

exports.StatisticQuery = StatisticQuery_1.StatisticQuery;

var StatisticsQuery_1 = require("./StatisticsQuery");

exports.StatisticsQuery = StatisticsQuery_1.StatisticsQuery;

var TimeseriesQuery_1 = require("./TimeseriesQuery");

exports.TimeseriesQuery = TimeseriesQuery_1.TimeseriesQuery;

var UrlQuery_1 = require("./UrlQuery");

exports.UrlQuery = UrlQuery_1.UrlQuery;

var ValueQuery_1 = require("./ValueQuery");

exports.ValueQuery = ValueQuery_1.ValueQuery;

var WindowQuery_1 = require("./WindowQuery");

exports.WindowQuery = WindowQuery_1.WindowQuery; // @endindex
// @index('./*', pp => `import * as ${pp.name} from '${pp.path}';`, { "ignore": ["./*.ts", "./*.md"] })

var transform = require("./transform");

exports.transform = transform;